import React from 'react'
import './style.sass'

const CustomButton = ({ buttonText, buttonExtraClass, ...rest }) => (
  <div className="custom-button-container">
    <button
      className={`btn btn-fill ${buttonExtraClass}`}
      {...rest}
    >
      {buttonText || "Click here"}
    </button>
  </div>
)

export default CustomButton